import { saleSettlementGeneratePeriod } from 'data/fieldMap';

// 结算标志
export const PreSettlementStatus = [
    { value: 0, label: '待结算' },
    { value: 10, label: '已抽单' },
    { value: 20, label: '已发票确认' },
    { value: 30, label: '已支付' },
];

// 合作方式
export const CooperationMode = [{ value: 1, label: '购销' }, { value: 2, label: '联营' }];

// 单据类型
export const BillType = [
    {
        label: '采购单',
        value: 1,
    },
    {
        label: '退货单',
        value: 2,
    },
    {
        label: '扣项单',
        value: 3,
    },
    {
        label: '调整单',
        value: 5,
    },
    {
        // 结算v3.1 "销售日结单" -> "联营销售对账单"
        label: '联营销售对账单',
        value: 6,
    },
    {
        label: '履约违规',
        value: 7,
    },
    {
        label: '品控违规',
        value: 8,
    },
];

// 销售对账单生成周期
export const SaleSettlementGeneratePeriod = Object.keys(saleSettlementGeneratePeriod).map((value) => ({ value: +value, label: saleSettlementGeneratePeriod[value] }));

// 扣项单的具体类型
export const BillSpecialType = [
    { value: 10, label: '降价补差' },
    { value: 20, label: '返利' },
    { value: 140, label: '履约违规' },
    { value: 150, label: '品控违规' },
    // {value: 30, label: '定额费用'}
];

// 扣项类型
export const ProtocolType = [
    { value: 10, label: '降价补差' },
    // {value: 20, label: '进价补差'},
    // {value: 30, label: '定额费用'},
    // {value: 40, label: '扣项调整'}
];

// 扣项协议状态
export const ProtocolStatus = [
    // {value: 10, label: '已删除'},
    { value: 20, label: '草稿' },
    { value: 30, label: '已生效' },
];

// 扣项单状态
export const CostStatus = [{ value: 10, label: '已取消' }, { value: 20, label: '待确认' }, { value: 30, label: '待盖章确认' }, { value: 40, label: '已完成' }];
export const CostStatusEmun = {
    10: '已取消',
    20: '待确认',
    30: '待盖章确认',
    40: '已完成',
};

// 扣项子类型
export const ProtocolItemType = [
    { value: 11, label: '库存补差' },
    { value: 12, label: '销量补差' },
];

// 对账主体
export const ReconciliationSubjectId = [
    // {value: 1000, label: '集团'},
    // {value: 2000, label: '区域公司'},
    { value: 3000, label: '分公司' },
    { value: 4000, label: '门店' },
];

// 支付方式
export const PayMethod = [{ value: 4, label: '账扣' }, { value: 1, label: '现金' }, { value: 2, label: '支票' }, { value: 3, label: '转账' }];

// 票扣标志
// prettier-ignore
export const InvoiceFlag = [
    { value: 1, label: '票扣' },
    { value: 2, label: '非票扣' },
];

// 扣项单状态
export const AgreementStatus = [{ value: 20, label: '草稿' }, { value: 10, label: '已删除' }, { value: 30, label: '已生效' }];

// 扣项分类
export const ApiCostCategoryEnum = [
    { value: 10, label: '降价补差' },
    { value: 20, label: '返利' },
    { value: 90, label: '质量扣重' },
    { value: 130, label: '营销服务费' },
    { value: 140, label: '履约违规' },
    { value: 150, label: '品控违规' },
    { value: 160, label: '其他违规' },
    { value: 170, label: '物资租赁' },
    // {value: 30, label: '定额费用'}
];

// 计算类型
export const ApiCalTypeEnum = [
    // {value: 3, label: '固定值'},
    { value: 1, label: '比例计算法' },
    { value: 2, label: '补差计算法' },
];

// 计算比例
export const ApiCalPercentEnum = [{ value: 3, label: '固定费率' }, { value: 1, label: '阶梯费率-超额' }, { value: 2, label: '阶梯费率-全额' }];

// 计算基数
export const ApiCalNumEnum = [
    // {value: 1, label: '固定金额'},
    { value: 2, label: '计算公式' },
];

// 扣项周期
export const CostPer = [
    { value: 1, label: '日' },
    { value: 2, label: '月' },
    { value: 3, label: '季' },
    { value: 4, label: '半年' },
    { value: 5, label: '年' },
    { value: 6, label: '随结算周期' },
];
// 商品范围
export const skuRangeEnum = [{ value: 1, label: '全部' }, { value: 2, label: '部分商品参与' }, { value: 3, label: '排除部分商品' }];

// 待结算业务类
export const billTypeEmun = {
    1: '采购单',
    2: '退货单',
    3: '扣项单',
};

// 参与商品
export const SkuSelection = [{ value: 1, label: '全选' }, { value: 2, label: '部分' }];

export const PayType = {
    /** 非周期付款 */
    NON_ROUTE_PAY_TYPE: 1,
    /** 周期付款 */
    ROUTE_PAY_TYPE: 2
}
